<template>
  <div
    class="menuBg"
    :class="[hasBackgroundImage ? 'menuBg-hasBackgroundImage' : '']"
  >
    <scan-and-go
      v-if="isScanEnabled && show_scanandgo_modal"
      @couponScanned="couponScanned"
      @close="show_scanandgo_modal = false"
    ></scan-and-go>
    <div class="main-menu main-menu-CheckOut">
      <order-header :is-payment="true" :is-payment-start="true" />
      <div class="listBlock-CheckOut" style="z-index: 1">
        <div class="headerWrapper">
          <div class="headerTitle">{{ $t(`checkout.header.title`) }}</div>
          <div class="headerText" v-if="isScanEnabled">
            {{ $t(`checkout.header.text`) }}
          </div>
        </div>
        <div class="btnBlock">
          <action-box
            v-if="site_setting.toilet_voucher_enabled"
            @click="show_scanandgo_modal = true"
            css-style="ScanToiletVoucher"
          >
            {{ $t(`checkout.btn.scan_toilet_voucher`) }}
          </action-box>
          <action-box
            v-if="site_setting.scan_and_go_enabled"
            @click="show_scanandgo_modal = true"
            css-style="ScanProduct"
          >
            {{ $t("checkout.btn.scan_product") }}
          </action-box>
          <action-box
            v-if="site_setting.coupons_enabled"
            @click="show_scanandgo_modal = true"
            css-style="ScanCoupon"
          >
            {{ $t("checkout.btn.scan_coupon") }}
          </action-box>
        </div>
        <div class="payWrapper">
          <div>
            <div class="payTitle">{{ $t(`checkout.header.title_pay`) }}</div>
          </div>
          <div
            class="btnBlock"
            :key="terminal.terminal"
            v-for="terminal in terminals"
          >
            <action-box
              :css-style="
                terminal.terminal_type == 'CIKAM' ? 'payCikam' : 'pay'
              "
              @click="pay(terminal)"
            >
              <span v-if="terminal.terminal_type == 'CIKAM'">
                {{ $t("checkout.btn.pay_with_cash") }}
              </span>
              <span v-else>
                {{ $t("checkout.btn.pay") }}
              </span>
            </action-box>
          </div>
        </div>
      </div>
      <div class="actionBlock">
        <div class="closeBtn text" @click="back_to_cart">
          {{ $t(`checkout.btn.back`) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderHeader from "@/components/order/OrderHeader.vue";
import ScanAndGo from "@/components/modals/scanandgo";
import ActionBox from "@/components/ActionBox";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { isBackgroundImageSet } from "@/utils/helpers";
import { isScanEnabled } from "@/utils/checkout";

export default {
  name: "Checkout",
  components: {
    ScanAndGo,
    ActionBox,
    OrderHeader
  },
  data() {
    return {
      show_scan_toilet_voucher_modal: false,
      show_scanandgo_modal: false
    };
  },
  created() {
    if (this.terminals.length === 1) {
      this.set_terminal(this.terminals[0]);
    }
    let noTerminalMode = this.terminals.length === 0;
    let onlyOneTerminal = this.terminals.length === 1;
    if (noTerminalMode || onlyOneTerminal) {
      if (!this.isScanEnabled) {
        this.logRouter({ name: "payment", router: this.$router });
      }
    }
  },
  computed: {
    ...mapGetters({
      site_setting: "SITE_SETTING",
      basket: "BASKET",
      terminals: "TERMINALS"
    }),
    hasBackgroundImage() {
      return isBackgroundImageSet("--page_Checkout_menuBg_background-image");
    },
    isScanEnabled() {
      return isScanEnabled(this.site_setting);
    }
  },
  methods: {
    ...mapActions({ logRouter: "LOG_ROUTER" }),
    ...mapMutations({
      setBasket: "SET_BASKET",
      add_coupon: "ADD_COUPON",
      set_terminal: "SET_TERMINAL"
    }),
    couponScanned(coupon) {
      //TODO not DRY see Order.vue
      console.log("Checkout: coupon scanned.");
      if (coupon.item) {
        let newBasket = this.basket.map(bi => {
          if (bi.uid === coupon.item) {
            return { ...bi, coupon };
          }
          return bi;
        });
        this.setBasket(newBasket);
        return;
      }
      //TODO: Apply coupon stuff to order, add to vuex
      this.add_coupon(coupon);
    },
    pay(terminal) {
      this.set_terminal(terminal);
      this.logRouter({ name: "payment", router: this.$router });
    },
    back_to_cart() {
      if (this.basket.length !== 0) {
        this.logRouter({ name: "order", router: this.$router });
      } else {
        this.logRouter({ name: "home", router: this.$router });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.main-menu-CheckOut {
  justify-content: flex-start;
}

.listBlock-CheckOut {
  padding-top: var(--page_Checkout_listBlock-CheckOut_padding-top);
}

.menuBg {
  background: var(--page_Checkout_menuBg_background);
}
.menuBg-hasBackgroundImage {
  background-image: var(--page_Checkout_menuBg_background-image);
}

.btnBlock {
  align-items: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 0;

  .actionBox {
    margin-bottom: 30px;
  }
}

.actionBlock {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 0 60px;
  position: absolute;
  bottom: 80px;
}

.closeBtn {
  width: 210px;
  height: 70px;
  border-radius: var(--page_Checkout_closeBtn_border-radius);
  font-family: var(--page_Checkout_closeBtn_font-family);
  border: var(--page_Checkout_closeBtn_border);
  color: var(--page_Checkout_closeBtn_color);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--page_Checkout_closeBtn_font-size);
  padding: var(--page_Checkout_closeBtn_padding);
  background-color: var(--page_Checkout_closeBtn_background-color);
}

.headerWrapper {
  position: absolute;
  top: 0;
  width: 1080px;
  text-align: center;
}

.headerTitle {
  color: var(--page_Checkout_headerTitle_color);
  font-family: var(--page_Checkout_headerTitle_font-family);
  font-size: var(--page_Checkout_headerTitle_font-size);
  text-transform: var(--page_Checkout_headerTitle_text-transform);
  transform: var(--page_Checkout_headerTitle_transform);
  line-height: var(--page_Checkout_headerTitle_line-height);
  padding: var(--page_Checkout_headerTitle_padding);
}

.headerText {
  color: var(--page_Checkout_headerText_color);
  font-size: var(--page_Checkout_headerText_font-size);
  font-family: var(--page_Checkout_headerText_font-family);
  padding: 0 100px 0 100px;
}

.payWrapper {
  background: var(--page_Checkout_payWrapper_background);
  border-radius: 20px;
  padding: 20px 20px 40px 20px;
  margin: 50px 150px 0 150px;
}

.payTitle {
  color: var(--page_Checkout_payTitle_color);
  font-family: var(--page_Checkout_payTitle_font-family);
  font-size: var(--page_Checkout_payTitle_font-size);
  letter-spacing: var(--page_Checkout_payTitle_letter-spacing);
  padding: var(--page_Checkout_payTitle_padding);
  text-align: center;
  text-transform: var(--page_Checkout_payTitle_text-transform);
}
</style>
